import React from 'react'
import Herohireseo from '../components/digital marketing/hireseo/herohire'
import Abouthire from '../components/digital marketing/hireseo/abouthire'
import Whyhire from '../components/digital marketing/hireseo/whyhire'
import Reviews from '../components/Reviews'
import Howhire from '../components/digital marketing/hireseo/howhire'
import Hirecards from '../components/digital marketing/hireseo/hirecards'
import Form1 from '../components/herosection/form'

function Hireseo() {
    return (
        <div>
            <Herohireseo />
            <Abouthire />
            <Whyhire />
            <Reviews />
            <Howhire />
            <Hirecards />
            <Form1 />
        </div>
    )
}

export default Hireseo